/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type CreateMentorShiftMutationVariables = Types.Exact<{
  name: Types.Scalars["String"];
  start_time: Types.Scalars["DateTimeISO"];
  end_time: Types.Scalars["DateTimeISO"];
  event_id: Types.Scalars["Int"];
  location: Types.Scalars["String"];
  max_count: Types.Scalars["Float"];
}>;

export type CreateMentorShiftMutation = {
  createMentorShift: Pick<
    Types.EventActivity,
    | "category"
    | "created_at"
    | "end_time"
    | "event_id"
    | "id"
    | "location"
    | "name"
    | "restrictions"
    | "start_time"
    | "updated_at"
  >;
};

export const CreateMentorShiftDocument = gql`
  mutation CreateMentorShift(
    $name: String!
    $start_time: DateTimeISO!
    $end_time: DateTimeISO!
    $event_id: Int!
    $location: String!
    $max_count: Float!
  ) {
    createMentorShift(
      name: $name
      start_time: $start_time
      end_time: $end_time
      event_id: $event_id
      location: $location
      max_count: $max_count
    ) {
      category
      created_at
      end_time
      event_id
      id
      location
      name
      restrictions
      start_time
      updated_at
    }
  }
`;

/**
 * __useCreateMentorShiftMutation__
 *
 * To run a mutation, you first call `useCreateMentorShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMentorShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMentorShiftMutation, { data, loading, error }] = useCreateMentorShiftMutation({
 *   variables: {
 *      name: // value for 'name'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *      event_id: // value for 'event_id'
 *      location: // value for 'location'
 *      max_count: // value for 'max_count'
 *   },
 * });
 */
export function useCreateMentorShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateMentorShiftMutation,
    CreateMentorShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateMentorShiftMutation,
    CreateMentorShiftMutationVariables
  >(CreateMentorShiftDocument, baseOptions);
}
export type CreateMentorShiftMutationHookResult = ReturnType<
  typeof useCreateMentorShiftMutation
>;
export type CreateMentorShiftMutationResult =
  ApolloReactCommon.MutationResult<CreateMentorShiftMutation>;
export type CreateMentorShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateMentorShiftMutation,
    CreateMentorShiftMutationVariables
  >;
